/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import BaseCom from "./BaseCom";
import videojs from 'video.js';
import 'video.js/dist/video-js.css'

export default class VideoPlayer extends BaseCom {
    constructor(props) {
        super(props);
        this.playerRef = React.createRef();
        this.videoRef = React.createRef();

    }
    componentDidMount() {
        const options = {
            controls: true,
            responsive: true,
            fluid: true,
            autoplay: this.props.autoplay,
            sources:
                [{
                    src: this.props.src,
                    type: this.props.type || 'video/mp4'
                }]
        }
        videojs(this.videoRef.current, options);
    }

    componentWillUnmount() {
        if(this.playerRef.current) {
            this.playerRef.current.dispose();
        }
    }

    render() {

        return (
            <div>
                <div data-vjs-player>
                    <video ref={this.videoRef} className="video-js"></video>
                </div>
            </div>
        );
    }
}